
import { Component, Prop, Watch, Vue, Emit } from "vue-property-decorator";
import { Getter, Action, namespace } from "vuex-class";
import vSelect from "vue-select";
import { ActionPlanTask } from "@/store/tasks/types";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { get } from "lodash";

@Component({
	components: {
		"v-select": vSelect
	},
	mixins: [validationMixin],
	validations: {
		selectedCaller: {
			required
		}
	}
})
export default class CallContactSetup extends Vue {
	@Prop()
	public value!: ActionPlanTask;

	public callList: any[] = [
		{ value: "CallList", name: "Call List" },
		{ value: "Fire Dept", name: "Fire Dept" },
		{ value: "Police", name: "Police" }
	];

	private selectedCaller: any = {};

	public mounted() {
		this.$v.$reset();

		this.loadFromTask();

		// Trigger initial validation
		this.onValidationChange(this.$v.$invalid);
	}

	@Watch("selectedCaller", { deep: true, immediate: true })
	public callContactSettingsChange(newValue) {
		this.$v.$touch();

		if (!this.$v.$error) {
			this.onInput();
		}
	}

	/**
	 * Fires an input event containing the new task data.
	 */
	@Emit("input")
	private onInput() {
		return {
			...this.value,
			taskText: `Call: ${this.selectedCaller.name}`,
			taskData: {
				...this.selectedCaller
			}
		};
	}

	/**
	 * Watcher/emitter for the validation state of this component,
	 * bubbles up vuelidate's validation state when it changes.
	 */
	@Watch("$v.$invalid")
	private onValidationChange($invalid: boolean) {
		this.$emit("validate-task", !$invalid);
	}

	private loadFromTask() {
		this.selectedCaller = get(this, ["value", "taskData"], {});
	}
}
